import React from 'react'
import Img from 'gatsby-image'
import Helmet from 'react-helmet'
import { backendURL } from '../../data/config.json'

//Components
import Fleet from '../../components/Fleet'

const FleetEs = props => {
  return (
    <div className="page fleet">

    <Helmet
          title={`Los mejores vehículos para alquiler en Budget Nicaragua`}
          meta={[
            {
              name: 'description',
              content:
                'Preguntas frecuentes sobre el alquiler de autos. Contáctenos: SJO: +506 2436-2070 / LIR: +506 2436-2071.',
            },
          ]}
          link={[
            {
              rel: 'alternate',
              hreflang: 'es',
              href:
                './en/fleet/fleet',
            },
          ]}
        />


      <div className="top-bg">
        <Img
         sizes={props.data.imageSharp.sizes}
          style={{ width: '100%', position: 'absolute', zIndex: '-1' }}
        />
      </div>

       
      
      <div className="excerpt">
        <h1>Conoce nuestra Flota</h1>
        <h3>
          Desde lujosos 4x4 hasta vehículos económicos, tenemos el automóvil que
          necesita.
        </h3>
      </div>
      <Fleet
        lang={props.pathContext.langKey}
        types={props.data.dataJson.fleetTypes}
        features={props.data.dataJson.fleetFeatures}
        displayFilter={true}
      />
    </div>
  )
}

export const query = graphql`
  query FleetEs {
      dataJson(id: { regex: "/fleet/" }) {
        ...FleetData
      }
      imageSharp(id: { regex: "/fleet-top-background2/" }) {
        sizes(maxWidth: 1600) {
          ...GatsbyImageSharpSizes
        }
      }
      allFile(filter: { relativeDirectory: { eq: "fleet" } }) {
        edges {
          node {
            name
            childImageSharp {
              resolutions {
                ...GatsbyImageSharpResolutions
              }
            }
          }
        }
      }
    }
    `


export default FleetEs



// WEBPACK FOOTER //
// ./src/pages/fleet/index.es.js